
export default {
  setFbData(state, value) {
    state.fbData = value;
  },
  setIsFbVerified(state, value){
    state.isFbVerified = value;
  },
  setSlackData(state, value) {
    state.slackData = value;
  },
  setIsSlackVerified(state, value){
    state.isSlackVerified = value;
  },
  setDiscordData(state, value) {
    state.discordData = value;
  },
  setIsDiscordVerified(state, value){
    state.isDiscordVerified = value;
  },
  setLinkedInData(state, value) {
    state.linkedInData = value;
  },
  setIsLinkedInVerified(state, value){
    state.isLinkedInVerified = value;
  },
  setTwitterData(state, value) {
    state.twitterData = value;
  },
  setIsTwitterVerified(state, value){
    state.isTwitterVerified = value;
  },
}
